import React from "react";
import useStyles from "./styles";
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
  Button,
} from "@material-ui/core";
import moment from "moment";
import ThumbUpIcon from "@material-ui/icons/ThumbUpAlt";
import DeleteIcon from "@material-ui/icons/Delete";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { useDispatch } from 'react-redux';
 import {deletePost ,likePost} from '../../../actions/posts'
const Post = ({ post, setCurrentId }) => {
  const classes = useStyles();
   const dispatch = useDispatch();
  return (
    <Card className={classes.card}>
      
      <CardMedia className={classes.media} image={post.selectedFile || 'https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png'} title={post.title} />
      <div className={classes.overlay}>
        <Typography variant="h6">{post.creator}</Typography>
        <Typography variant="body2">{moment(post.cretedAt).fromNow()}</Typography>
      </div>
      <div className={classes.overlay2}>
        <Button style={{ color: "white" }}
         size="small"
          onClick={() => setCurrentId(post._id)}>
          <MoreHorizIcon fontSize="default" /> </Button>
      </div>
      <div className={classes.details}>
      <Typography variant="body2" color="textSecondary" component="h2">{post.tags.map((tag) => `#${tag} `)}</Typography>
      </div>
      <Typography className={classes.title} gutterBottom variant="h5" component="h2">{post.title}</Typography>
        <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">{post.message}</Typography>
        </CardContent>
          <CardActions className={classes.cardActions}>
            <Button color="primary" size="small" onClick={() => dispatch(likePost(post._id))}> <ThumbUpIcon fontSize="small" /> &nbsp; Like &nbsp; {post.likeCount}</Button>
            <Button color="primary" size="small" onClick={() => dispatch(deletePost(post._id))}> <DeleteIcon fontSize="small" /> Delete </Button>
          </CardActions>
       
    
    </Card>
  );
};
export default Post;
